"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fitText = void 0;
const measure_text_1 = require("../layouts/measure-text");
const sampleSize = 100;
/*
 * @description Calculates the font size needed to fit text into a specified width container.
 * @see [Documentation](https://remotion.dev/docs/layout-utils/fit-text)
 */
const fitText = ({ text, withinWidth, fontFamily, fontVariantNumeric, fontWeight, letterSpacing, validateFontIsLoaded, additionalStyles, textTransform, }) => {
    const estimate = (0, measure_text_1.measureText)({
        text,
        fontFamily,
        fontSize: sampleSize,
        fontWeight,
        fontVariantNumeric,
        letterSpacing,
        validateFontIsLoaded,
        textTransform,
        additionalStyles,
    });
    return { fontSize: (withinWidth / estimate.width) * sampleSize };
};
exports.fitText = fitText;
